module.exports = __webpack_public_path__ + "img/1.348609a3.png";